import axios from "axios";
import { Base_URL } from "../url";

export const fetchPaymentDateGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PaymentDateGroupMaster/GetAllGroups`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching payment date groups!";
  }
};

export const downloadGroupsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/PaymentDateGroupMaster/DownloadGroupsExcel`,
      {}, 
      {
        responseType: 'blob' 
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading payment date groups data!";
  }
};